import { UnfilteredIcd } from "@fusion-advantage/backcompat"
import { sqlQuery, sqlRun } from "./ldb"
import { bulkInsert } from "./bulkInsert"
import { err, ok, Result } from "neverthrow"
import { FusionError, serializeFusionError } from '@fusion-advantage/backcompat'
import { selectAllText } from "./LdbBrowser"

// for info on distinction between Drug and Unfiltered ICD
// see comments in Icd.ts

export const selectAllUnfilteredIcdText = async (): Promise<string> => {
	return selectAllText('unfilteredIcd', ['Icd10Code', 'Description'])
}

export const selectHasUnfilteredIcds = async (dateOfService: string): Promise<Result<boolean, FusionError>> => {
	let r = await sqlQuery<{has: number}>(
		`
			select exists (
				select 1
				  from unfilteredIcd
				 where DateOfService = ?
				 limit 1
			) as has
		`,
		[
			dateOfService,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('hasUnfilteredIcds', r.error))
	}
	const [{has}] = r.value
	return ok(has > 0)
}

export const selectUnfilteredIcd = async (dateOfService: string, icdCodeQuery: string): Promise<Result<UnfilteredIcd[], FusionError>> => {
	const where = icdCodeQuery ? ' and Icd10Code like ?' : ''
	const params = icdCodeQuery ? [icdCodeQuery + '%'] : []
	let r = await sqlQuery<UnfilteredIcd>(
		`
			select Icd10Code, Description
			  from unfilteredIcd
			 where DateOfService = ?
			       ${where}
			 limit 50
		`,
		[
			dateOfService,
			...params,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('selectUnfilteredIcd', r.error))
	}
	return ok(r.value)
}

export const ldbUnfilteredIcdBulkInsert = async (dateOfService: string, codes: UnfilteredIcd[]): Promise<Result<void, FusionError>> => {
	let r = await sqlRun(
		`
			delete from unfilteredIcd
			 where dateOfService = ?
		`,
		[
			dateOfService,
		],
	)
	if(r.isErr()) {
		return err(serializeFusionError('ldbUnfilteredIcdBulkInsert', r.error))
	}
	let params = []
	for (let m of codes) {
		params.push(dateOfService, m.Icd10Code, m.Description)
	}
	r = await bulkInsert('unfilteredIcd', params, 3)
	if(r.isErr()) {
		return err(serializeFusionError('ldbDrugIcdBulkInsert', r.error))
	}
	return ok()
}
